import { render, staticRenderFns } from "./blogger_promotion_record.vue?vue&type=template&id=6b86c372&scoped=true"
import script from "./blogger_promotion_record.vue?vue&type=script&lang=ts"
export * from "./blogger_promotion_record.vue?vue&type=script&lang=ts"
import style0 from "./blogger_promotion_record.vue?vue&type=style&index=0&id=6b86c372&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b86c372",
  null
  
)

export default component.exports